export interface Products {
  id: string;
  title: string;
  subject: string;
  desc: string;
  location: string;
  duration: number;
  images: string[];
  product: unknown[];
}

/**
 * POST — Add new contact info
 */
export async function postProduct(productData: Products) {
  const response = await fetch(`/api/addproducts`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(productData),
  });

  if (!response.ok) {
    throw new Error(`Error adding product info: ${response.statusText}`);
  }

  const data = await response.json();
  return data;
}
